import { render, staticRenderFns } from "./search-normal.vue?vue&type=template&id=6579b0ac&"
import script from "./search-normal.vue?vue&type=script&lang=js&"
export * from "./search-normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6579b0ac')) {
      api.createRecord('6579b0ac', component.options)
    } else {
      api.reload('6579b0ac', component.options)
    }
    module.hot.accept("./search-normal.vue?vue&type=template&id=6579b0ac&", function () {
      api.rerender('6579b0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/search-normal.vue"
export default component.exports